module.exports = __webpack_public_path__ + "img/img_company_opinion4.2cba3ddc.svg";